import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { addGiftOrderInfo } from "@/api/php/me";
import { Toast } from "vant";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'IntegralAddress',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "6717092b-btnColor": (btnColor.value),
  "6717092b-btnTextColor": (btnTextColor.value)
}))

const { t } = useI18n()

const router = useRouter();
const route = useRoute();
const name = ref('');
const phone = ref('');
const address = ref('');
const code = ref('');
// const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const primaryColor = '#0D0D0D';
const submit = async () => {
    if (name.value == "") {
        return Toast.fail(t('me.qsrplnr'))
    }
    if (phone.value == "") {
        return Toast.fail(t('me.srndsjh'))
    }
    if (address.value == "") {
        return Toast.fail(t('me.srxxdz'))
    }
    if (code.value == "") {
        return Toast.fail(t('me.inputcode'))
    }
    console.log(route.query.id);

    const res: any = await addGiftOrderInfo({
        name: name.value,
        phone: phone.value,
        location: address.value,
        postal_code: code.value,
        order_id: route.query.id,
        num: route.query.num

    })
    if (res && res.code == 200) {
        Toast.success('添加成功')
        router.back()

    }

}

const btnColor = ref("#ECECEC")
const btnTextColor = ref("#898989")
const checkText = () => {
    if (name.value == "") {
        btnColor.value = "#ECECEC";
        btnTextColor.value = "#898989"
        return
    }
    if (phone.value == "") {
        btnColor.value = "#ECECEC";
        btnTextColor.value = "#898989"
        return
    }
    if (address.value == "") {
        btnColor.value = "#ECECEC";
        btnTextColor.value = "#898989"
        return
    }
    if (code.value == "") {
        btnColor.value = "#ECECEC";
        btnTextColor.value = "#898989"
        return
    }
    // primaryColor
    btnColor.value = primaryColor;
    btnTextColor.value = "#fff"


}



const __returned__ = { t, router, route, name, phone, address, code, primaryColor, submit, btnColor, btnTextColor, checkText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})